import {BaseModel} from './base.model';
import {IDomain} from './database';


export class Domain extends BaseModel<IDomain> implements IDomain {
  business_unit_id: number;
  chief_id: number;
  city: string;
  created_at: Date | null;
  deleted_at: Date | null;
  has_sectors: any;
  id: number;
  manager_id: number;
  name: string;
  updated_at: Date | null;
  settings: any;

}
